import NotificationSummary from 'containers/Chats/NotificationSummary'
import { ReactComponent as User } from 'assets/account.svg'
import useTranslation from 'hooks/useTranslation'
import Actions from './Actions'

const Main = () => {
  const { t } = useTranslation('account')
  return (
    <>
      <div>
        <div className='account__header'>
          <div className='account__icon'>
            <User />
          </div>

          <div className='title'>
            <div>{t('customerPanel')}</div>
            <div>{t('subTitle')}</div>
          </div>
        </div>
      </div>

      <NotificationSummary secondaryTheme />
      <Actions />
    </>
  )
}

export default Main